module.exports = __webpack_public_path__ + "808541ba3536d01d8e1e4af88407092e.svg";